module.exports = __webpack_public_path__ + "img/error_icon.774cb369.svg";